module.exports = __webpack_public_path__ + "static/media/one_sending_wave_header@2x.7e215d44.png";